import { AmountBlock } from './amountBlock';
import { TicketsBlock } from './ticketsBlock';
import { BetButtonsBlock } from './betButtonsBlock';
import AddTicket from './ticketsBlock/addTicket';

export function BetBlock() {
  return (
    <div className='keno-game-footer'>
      <div className='keno-game-footer-inner'>
        <div className='keno-bet-block'>
          <AmountBlock />
          <TicketsBlock />
          <div className='keno-bet-buttons-block'>
            <AddTicket />
            <BetButtonsBlock />
          </div>
        </div>
      </div>
    </div>
  );
}
